import { AssistanceGrid, StackedBarStep } from "../../components/BarChart"
import { Card, CardsInfoTitleSub, CardTitle } from "../../components/Card"
import { RadarRecharts } from "../../components/Chart"
import { EmptyGraph } from "../../components/Empty"
import { HeaderContent } from "../../components/Header"
import { StepVariationTable } from "../../components/Table"
import "./styles.scss"

export const AssistanceScreen = ({
  users,
  goTo,
  formatBarChartAssistance,
  countTotalAssistance,
  countTotalReferenceAssistance,
  countTotalContent,
  countTotalReferenceContent,
  formatRadar,
  allData,
  projectId
}) => {

  const countProducers = (users && users?.length) || 0
  return (
    <>
      <div
        className="assistance-cards-container no-border"
        style={projectId === '5c030578-f9ea-419b-a985-7e2c06a861e9' ? 
          { gridTemplateColumns: 'repeat(1, 1fr)' } :
          {}
        }
      >
        {projectId !== '5c030578-f9ea-419b-a985-7e2c06a861e9' &&
          <>
            <CardsInfoTitleSub title={countProducers} subtitle="Nº de produtores totais no projeto" />
            {/* <CardsInfoTitleSub
              onClick={() => goTo("/details/content")}
              title={countTotalContent}
              subPercent={countTotalReferenceContent}
              percent={countTotalReferenceContent !== 0 && parseFloat((countTotalContent/countTotalReferenceContent)*100 - 100).toFixed(1)}
              hasPercent={true}
              subtitle="Nº de produtores em assistência técnica no período"
            /> */}
          </>
        }
        <CardsInfoTitleSub
          onClick={() => goTo("/details/assistance")}
          title={countTotalAssistance}
          subPercent={countTotalReferenceAssistance}
          percent={countTotalReferenceAssistance !== 0 && parseFloat((countTotalAssistance/countTotalReferenceAssistance)*100).toFixed(1)}
          hasPercent={true}
          subtitle="Nº de atendimentos"
        />
      </div>
      <Card className="chart-container no-border">
        <HeaderContent>
          <CardTitle title="Média das Notas" />
        </HeaderContent>
        <div className="card-chart-content">
          {formatRadar?.length > 0 ?
            <div>
              <RadarRecharts data={{fields: formatRadar}} />
            </div> :
            <EmptyGraph />
          }
        </div>
      </Card>
      <Card className="chart-container no-border">
        <HeaderContent>
          <CardTitle title="Quantidade de atendimentos por tema abordado" />
        </HeaderContent>
        <div className="card-chart-content">
          
          {formatBarChartAssistance?.length > 0 ?
            <div className="stackbar">
              <StackedBarStep data={formatBarChartAssistance} />
            </div>
            : <EmptyGraph />
          }
        </div>
      </Card>
      <Card className="chart-container no-border">
        <HeaderContent>
          <CardTitle title="Tabela de comparação de atendimentos entre períodos" />
        </HeaderContent>
        <div className="card-chart-content">
          {formatBarChartAssistance?.length > 0 ?
            <StepVariationTable data={formatBarChartAssistance}/> :
            <EmptyGraph />
          }
        </div>
      </Card>
      <Card className="chart-container no-border">
        <HeaderContent>
          <CardTitle title="Detalhamento dos atendimentos efetuados" />
        </HeaderContent>
        <div className="card-chart-content grid">
          {allData?.length > 0 ?
            <AssistanceGrid rows={allData} /> :
            <EmptyGraph />
          }
        </div>
      </Card>
    </>
  )
}